import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('cancelButton');

    return {
        CANCEL: t('cancel')
    };
};

export default useTranslation;
